import * as React from 'react';

import { Button } from '@coursera/cds-core';

import { useEnrollmentDiaglogEventingContext } from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/EnrollmentDiaglogEventingContext';
import type { EnrollmentDiaglogEventingContextType } from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/EnrollmentDiaglogEventingContext';
import type { TrackingProps } from 'bundles/page/components/TrackedLink2';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

type Props = {
  trackingName: string;
  href: string;
  ctaLabel: string;
};

const EnrollmentDialogCTAButton = ({ trackingName, href, ctaLabel }: Props) => {
  const enrollmentDialogEventingData: EnrollmentDiaglogEventingContextType | undefined =
    useEnrollmentDiaglogEventingContext();
  const termName = enrollmentDialogEventingData?.termName;
  const courseName = enrollmentDialogEventingData?.courseName;
  const courseCreditValue = enrollmentDialogEventingData?.courseCreditValue;
  const isCourseElective = enrollmentDialogEventingData?.isCourseElective;

  return (
    <Button
      component={(props: TrackingProps) => (
        <TrackedA
          {...props}
          data={{
            courseName,
            courseCreditValue,
            ctaLabel,
            isCourseElective,
            termName,
          }}
        />
      )}
      trackingName={trackingName}
      withVisibilityTracking
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {ctaLabel}
    </Button>
  );
};

export default EnrollmentDialogCTAButton;
